/* Slick Slider */

jQuery(document).ready(function($){
  $('.c-history-slider').slick({
	  autoplay: false,
	  speed: 800,
	  pauseOnHover: false,
	  arrows: true,
	  dots: true,
	  fade: false,
		adaptiveHeight: true
  });
});
